import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBaseResponse } from '../../../utilities/http-utilities.service';
import { ICheckIn } from '../items-modal/work-instruction-check-in/work-instruction-check-in.interface';

@Injectable()
export class WorkInstructionStepperService {
  constructor(private readonly http: HttpClient) {}

  /** Ongoing check-ins on the work instruction and on its steps. */
  public getOngoingCheckIns(itemGuideAssignmentId: number): Observable<IBaseResponse<ICheckIn[]>> {
    const params: HttpParams = new HttpParams().set('itemGuideAssignmentIds', itemGuideAssignmentId);

    return this.http.get<IBaseResponse<ICheckIn[]>>('check-ins/ongoing', { params });
  }
}
